const cta = (text) => `
      <h2>Schedule with ComfortMaster</h2>
      <p>${text} Call (859) 255-0728 or <a href="/contact">request service online</a>. We proudly serve Lexington, Nicholasville, Georgetown, Richmond, Winchester, and all of Central Kentucky.</p>
`;

export const springArticles = [
  {
    id: 73,
    slug: 'spring-ac-tune-up-checklist-kentucky',
    title: 'Spring AC Tune-Up Checklist: Get Your Kentucky Home Ready Before the Heat Hits',
    excerpt: 'Central Kentucky can jump from 60°F to 85°F in a single week. A spring AC tune-up catches small problems before they become expensive summer breakdowns. Here is the complete DIY and professional checklist.',
    image: 'https://images.unsplash.com/photo-1758798157512-f0a864c696c9?w=800&auto=format&fit=crop',
    date: 'March 16, 2026',
    dateISO: '2026-03-16',
    readTime: '8 min read',
    category: 'Spring Guide',
    season: 'spring',
    content: `
      <h2>Why Spring Is the Best Time for AC Maintenance</h2>
      <p>Most air conditioners sit idle from October through April. During those months, leaves, pollen, and debris collect in the outdoor condenser, and small issues like weak capacitors or low refrigerant go unnoticed. Scheduling maintenance in March or April means you beat the summer rush, get flexible appointment times, and avoid paying for emergency repairs on the first 90°F day.</p>
      <p>According to the U.S. Department of Energy, a well-maintained air conditioner can use 5-15% less energy than a neglected one. For a typical Lexington home, that can mean $50-$150 in savings every cooling season.</p>

      <h2>DIY Spring AC Checklist</h2>
      <h3>1. Replace Your Air Filter</h3>
      <p>Start the season with a fresh filter. A clogged filter restricts airflow, forces your blower to work harder, and can cause the evaporator coil to freeze. Check it monthly during cooling season.</p>
      <h3>2. Clear the Outdoor Unit</h3>
      <ul>
        <li>Remove leaves, sticks, and grass clippings from around the condenser</li>
        <li>Trim shrubs and plants to leave at least 2 feet of clearance on all sides</li>
        <li>Gently rinse the fins with a garden hose (never a pressure washer)</li>
      </ul>
      <h3>3. Check the Condensate Drain Line</h3>
      <p>Pour a cup of white vinegar into the drain line access point to prevent algae buildup. A clogged drain line is one of the most common causes of summer water leaks and AC shutdowns.</p>
      <h3>4. Test Your Thermostat</h3>
      <p>Switch to cooling mode and set the temperature 5 degrees below room temperature. The system should start within a few minutes. Replace thermostat batteries while you are at it.</p>

      <h2>What a Professional Spring Tune-Up Includes</h2>
      <ul>
        <li><strong>Refrigerant level check</strong> - low refrigerant usually means a leak that needs repair</li>
        <li><strong>Electrical inspection</strong> - capacitors, contactors, and wiring tested for wear</li>
        <li><strong>Coil cleaning</strong> - dirty condenser and evaporator coils reduce efficiency</li>
        <li><strong>Blower motor and belt inspection</strong></li>
        <li><strong>Airflow and temperature split measurement</strong></li>
        <li><strong>Safety controls and thermostat calibration</strong></li>
      </ul>

      <h2>Warning Signs to Watch For</h2>
      <p>If you notice any of these during your first test run, call a technician before the heat arrives: warm air from vents, unusual buzzing or grinding, short cycling, ice on the refrigerant lines, or a musty smell.</p>
      ${cta('Book your spring AC tune-up now and enjoy priority scheduling before the summer rush. Comfort Loyalty Club members receive their spring tune-up as part of membership.')}
    `
  },
  {
    id: 74,
    slug: 'spring-allergies-indoor-air-quality-lexington',
    title: 'Spring Allergy Season in Lexington: How Your HVAC System Can Help You Breathe Easier',
    excerpt: 'The Bluegrass region is consistently ranked among the most challenging places in America for spring allergies. Learn how filters, air purifiers, and duct cleaning can keep tree and grass pollen out of your home.',
    image: 'https://images.unsplash.com/photo-1575721697801-937774cc44ab?w=800&auto=format&fit=crop',
    date: 'April 2, 2026',
    dateISO: '2026-04-02',
    readTime: '7 min read',
    category: 'Spring Guide',
    season: 'spring',
    content: `
      <h2>Why Spring Allergies Are So Tough in Central Kentucky</h2>
      <p>Louisville and Lexington regularly appear on national lists of the most challenging allergy cities. Our long growing season, abundant trees (oak, maple, birch, and walnut), and rolling bluegrass fields create heavy pollen counts from March through June.</p>
      <p>Pollen does not stay outside. It rides in on clothing, pets, and open windows, and then your HVAC system circulates it through every room unless you have the right filtration in place.</p>

      <h2>HVAC Upgrades That Reduce Allergens</h2>
      <h3>Upgrade to a MERV 11-13 Filter</h3>
      <p>Basic fiberglass filters only catch large dust particles. A pleated MERV 11-13 filter captures most pollen, pet dander, and mold spores. Ask us to verify your system can handle the airflow of a higher-efficiency filter.</p>
      <h3>Whole-Home Air Purifiers</h3>
      <p>Media air cleaners and electronic air purifiers installed in your ductwork treat all the air in your home - not just one room like a portable unit.</p>
      <h3>UV Germicidal Lights</h3>
      <p>UV lights installed near the evaporator coil kill mold and bacteria that thrive in the damp spring environment inside your air handler.</p>
      <h3>Professional Duct Cleaning</h3>
      <p>If your ducts have not been cleaned in 5+ years, they likely hold a winter's worth of dust and debris. Cleaning them at the start of allergy season gives your filter a fresh start.</p>

      <h2>Simple Habits That Help</h2>
      <ul>
        <li>Keep windows closed on high-pollen days and run the AC instead</li>
        <li>Set your thermostat fan to "Auto" rather than "On" unless you have high-efficiency filtration</li>
        <li>Change your filter every 30-60 days during peak pollen season</li>
        <li>Keep indoor humidity between 30-50% to discourage mold and dust mites</li>
      </ul>
      ${cta('Our indoor air quality specialists can test your home and recommend the right filtration solution for your family.')}
    `
  },
  {
    id: 75,
    slug: 'spring-storm-hvac-protection-kentucky',
    title: 'Spring Storm Season: How to Protect Your HVAC System from Kentucky Thunderstorms and Flooding',
    excerpt: 'Spring in Kentucky brings severe thunderstorms, lightning, and flash flooding. Learn how surge protection, sump pumps, and a few smart steps can protect your heating, cooling, and plumbing systems.',
    image: 'https://images.unsplash.com/photo-1776860150250-757406c52438?w=800&auto=format&fit=crop',
    date: 'April 20, 2026',
    dateISO: '2026-04-20',
    readTime: '7 min read',
    category: 'Spring Guide',
    season: 'spring',
    content: `
      <h2>Kentucky Storms and Your HVAC Equipment</h2>
      <p>April and May are peak severe weather months in Central Kentucky. Lightning strikes, power surges, hail, high winds, and standing water can all damage your outdoor condenser and indoor equipment. A little preparation can prevent thousands of dollars in repairs.</p>

      <h2>Before the Storm</h2>
      <h3>Install Surge Protection</h3>
      <p>Modern AC systems and heat pumps contain sensitive circuit boards. A whole-home or HVAC-dedicated surge protector guards against the voltage spikes that occur when power is restored after an outage.</p>
      <h3>Secure the Outdoor Unit</h3>
      <ul>
        <li>Remove loose yard items that could become projectiles</li>
        <li>Make sure the condenser sits level on its pad</li>
        <li>Consider hail guards if your area sees frequent hail</li>
      </ul>
      <h3>Test Your Sump Pump</h3>
      <p>Pour a bucket of water into the sump pit to verify the pump activates. A battery backup sump pump keeps your basement dry even when the power goes out.</p>

      <h2>During the Storm</h2>
      <p>If a severe thunderstorm is directly overhead, consider turning your AC off at the thermostat to reduce risk from lightning-induced surges. Never go outside to cover your unit during a storm.</p>

      <h2>After the Storm</h2>
      <ul>
        <li>Inspect the outdoor unit for debris, bent fins, or physical damage</li>
        <li>If the unit was submerged in flood water, <strong>do not turn it on</strong> - call a professional first</li>
        <li>Wait about 30 minutes after power returns before restarting your AC to let the voltage stabilize</li>
        <li>Check basements and crawl spaces for standing water near furnaces and water heaters</li>
      </ul>
      ${cta('Need a post-storm inspection, surge protector installation, or sump pump service? Our technicians are ready to help.')}
    `
  },
  {
    id: 76,
    slug: 'repair-or-replace-ac-before-summer',
    title: 'Repair or Replace? How to Decide on Your Air Conditioner Before Summer Arrives',
    excerpt: 'If your AC limped through last summer, spring is the smartest time to decide whether to repair or replace it. Use the $5,000 rule, age guidelines, and efficiency math to make a confident decision.',
    image: 'https://images.unsplash.com/photo-1757219525975-03b5984bc6e8?w=800&auto=format&fit=crop',
    date: 'May 11, 2026',
    dateISO: '2026-05-11',
    readTime: '8 min read',
    category: 'Spring Guide',
    season: 'spring',
    content: `
      <h2>Why Decide in Spring?</h2>
      <p>Replacing an air conditioner in July often means long waits, limited equipment choices, and sweltering days without cooling. In spring, installers have more availability, you have time to compare options, and you can take advantage of manufacturer rebates and utility incentives.</p>

      <h2>The $5,000 Rule</h2>
      <p>Multiply the age of your system by the estimated repair cost. If the result is more than $5,000, replacement is usually the better investment. For example, a 12-year-old AC with a $500 repair: 12 x $500 = $6,000, so replacement makes sense.</p>

      <h2>Signs It Is Time to Replace</h2>
      <ul>
        <li><strong>Age:</strong> Your system is 12-15+ years old</li>
        <li><strong>R-22 refrigerant:</strong> Systems installed before 2010 may use R-22, which is no longer produced and is very expensive to recharge</li>
        <li><strong>Rising bills:</strong> Your cooling costs climb every summer even with maintenance</li>
        <li><strong>Frequent repairs:</strong> You have called for service more than twice in two years</li>
        <li><strong>Uneven comfort:</strong> Some rooms are always hot or humid</li>
      </ul>

      <h2>When Repair Makes Sense</h2>
      <ul>
        <li>The system is under 10 years old and has been maintained</li>
        <li>The issue is a single component such as a capacitor, contactor, or fan motor</li>
        <li>The repair costs less than 25% of a new system</li>
      </ul>

      <h2>The Efficiency Advantage</h2>
      <p>New systems meeting current SEER2 standards can use 20-40% less electricity than a 15-year-old unit. Paired with a variable-speed air handler, they also remove more humidity - a big deal in a humid Kentucky summer.</p>
      ${cta('Not sure which way to go? Our comfort advisors provide honest, no-pressure assessments and free replacement estimates, with financing options available.')}
    `
  }
];

export const summerArticles = [
  {
    id: 77,
    slug: 'kentucky-heat-wave-ac-survival-guide',
    title: 'Kentucky Heat Wave Survival Guide: Keep Your AC Running When Temperatures Soar',
    excerpt: 'When the heat index climbs past 100°F in Central Kentucky, your air conditioner works harder than at any other time of year. Here is how to keep it running, keep your family safe, and know when to call for help.',
    image: 'https://images.unsplash.com/photo-1751889188945-f15e42becd73?w=800&auto=format&fit=crop',
    date: 'June 1, 2026',
    dateISO: '2026-06-01',
    readTime: '8 min read',
    category: 'Summer Guide',
    season: 'summer',
    content: `
      <h2>How Heat Waves Stress Your Air Conditioner</h2>
      <p>Most residential air conditioners are designed to keep your home about 20 degrees cooler than the outside temperature. When it is 98°F outside with high humidity, your system may run nonstop and still struggle to hold 72°F. That is normal - but it also exposes weak parts that are ready to fail.</p>

      <h2>Tips to Help Your AC Keep Up</h2>
      <ul>
        <li><strong>Set it and leave it:</strong> Pick a steady temperature (75-78°F) rather than making big adjustments</li>
        <li><strong>Close blinds and curtains</strong> on sun-facing windows during the afternoon</li>
        <li><strong>Avoid heat-generating chores</strong> like using the oven or dryer between 2-7 PM</li>
        <li><strong>Use ceiling fans</strong> set counterclockwise to feel 4 degrees cooler</li>
        <li><strong>Hose off the condenser</strong> in the early morning if it is covered in dirt or cottonwood fluff</li>
        <li><strong>Check your filter</strong> - in peak summer it may need replacing every 30 days</li>
      </ul>

      <h2>Warning Signs of an AC Problem</h2>
      <ul>
        <li>Ice forming on the copper lines or indoor coil</li>
        <li>The outdoor fan is not spinning while the system is running</li>
        <li>Warm air from the vents</li>
        <li>Breaker tripping repeatedly</li>
        <li>Water pooling around the indoor unit</li>
      </ul>
      <p>If you see ice, turn the cooling off and set the fan to "On" to thaw the coil, then call for service. Running a frozen system can damage the compressor.</p>

      <h2>Stay Safe During Extreme Heat</h2>
      <p>Heat is the leading weather-related cause of death in the U.S. Check on elderly neighbors, never leave children or pets in vehicles, and if your AC fails, move to the lowest level of your home or visit a public cooling center while you wait for repair.</p>
      ${cta('Is your AC losing the battle against the heat? ComfortMaster offers fast, same-day AC repair across Central Kentucky.')}
    `
  },
  {
    id: 78,
    slug: 'summer-humidity-control-kentucky-homes',
    title: 'Summer Humidity Control: Why Your Kentucky Home Feels Sticky and How to Fix It',
    excerpt: 'Is your home cool but still clammy? Kentucky summers regularly push humidity above 70%. Learn the ideal indoor humidity level, why oversized AC units make it worse, and how whole-home dehumidifiers help.',
    image: 'https://images.unsplash.com/photo-1610389337008-84e005329867?w=800&auto=format&fit=crop',
    date: 'June 8, 2026',
    dateISO: '2026-06-08',
    readTime: '7 min read',
    category: 'Summer Guide',
    season: 'summer',
    content: `
      <h2>The Ideal Indoor Humidity Level</h2>
      <p>Aim for 40-50% relative humidity during summer. Above 55%, your home feels sticky, dust mites multiply, and mold can grow in basements and closets. An inexpensive digital hygrometer lets you track humidity in different rooms.</p>

      <h2>Why Your AC May Not Be Removing Enough Moisture</h2>
      <h3>Oversized Equipment</h3>
      <p>An AC that is too large cools the air quickly and shuts off before it has time to pull moisture out. This "short cycling" leaves the house cold and clammy.</p>
      <h3>Fan Set to "On"</h3>
      <p>Running the blower continuously can re-evaporate moisture from the wet coil back into your home. Use the "Auto" setting during humid months.</p>
      <h3>Dirty Coils or Low Refrigerant</h3>
      <p>Both reduce your system's ability to cool the coil enough to condense moisture.</p>

      <h2>Solutions That Work</h2>
      <ul>
        <li><strong>Whole-home dehumidifier:</strong> Installs with your HVAC system and controls humidity throughout the house</li>
        <li><strong>Variable-speed AC:</strong> Runs longer at lower speeds, removing much more moisture</li>
        <li><strong>Crawl space encapsulation:</strong> Seals a major source of moisture common in Kentucky homes</li>
        <li><strong>Bathroom and kitchen exhaust fans:</strong> Run them during and 20 minutes after showers and cooking</li>
      </ul>

      <h2>Bonus: Lower Humidity Saves Money</h2>
      <p>Dry air feels cooler, so most homeowners can raise the thermostat 2-3 degrees once humidity is under control - saving up to 9% on cooling costs.</p>
      ${cta('Our technicians can measure your home humidity and recommend the right dehumidification solution.')}
    `
  },
  {
    id: 79,
    slug: 'lower-summer-energy-bills-lexington',
    title: '10 Ways to Lower Your Summer Energy Bills in Lexington Without Sacrificing Comfort',
    excerpt: 'Cooling can account for nearly half of your summer electric bill. These 10 practical, Kentucky-tested tips - from smart thermostat schedules to sealing duct leaks - can cut your costs by 20% or more.',
    image: 'https://images.unsplash.com/photo-1545259741-2ea3ebf61fa3?w=800&auto=format&fit=crop',
    date: 'June 15, 2026',
    dateISO: '2026-06-15',
    readTime: '8 min read',
    category: 'Summer Guide',
    season: 'summer',
    content: `
      <h2>Where Your Summer Energy Dollars Go</h2>
      <p>For most Central Kentucky homes, air conditioning is the single largest energy expense from June through August. The good news: small changes add up quickly.</p>

      <h2>10 Proven Money-Saving Tips</h2>
      <h3>1. Use a Smart Thermostat Schedule</h3>
      <p>Set the temperature to 78°F when you are home and 82-85°F when you are away. Smart thermostats learn your routine and can save around 8% annually.</p>
      <h3>2. Keep Up with Filter Changes</h3>
      <p>A dirty filter can increase energy use by up to 15%.</p>
      <h3>3. Seal Leaky Ducts</h3>
      <p>The typical home loses 20-30% of conditioned air through duct leaks, often in attics and crawl spaces.</p>
      <h3>4. Add Attic Insulation</h3>
      <p>Kentucky attics can exceed 140°F in summer. Proper insulation (R-38 to R-60) keeps that heat out of your living space.</p>
      <h3>5. Shade Your Windows</h3>
      <p>Blackout curtains or solar screens on south- and west-facing windows block a large share of solar heat gain.</p>
      <h3>6. Run Ceiling Fans Counterclockwise</h3>
      <p>Fans let you raise the thermostat about 4°F with no loss of comfort. Turn them off when you leave the room.</p>
      <h3>7. Shift Heat-Producing Chores</h3>
      <p>Run dishwashers, dryers, and ovens in the early morning or late evening.</p>
      <h3>8. Shade the Outdoor Unit</h3>
      <p>A shaded condenser can run up to 10% more efficiently - just keep 2 feet of clearance for airflow.</p>
      <h3>9. Schedule a Mid-Season Check</h3>
      <p>Clean coils and the correct refrigerant charge keep your system running at its rated efficiency.</p>
      <h3>10. Consider an Upgrade</h3>
      <p>If your AC is 12+ years old, a high-efficiency system or geothermal heat pump can reduce cooling costs by 30-50%.</p>
      ${cta('Want a personalized energy-saving plan? Ask about our Comfort Loyalty Club, which includes seasonal tune-ups and member discounts.')}
    `
  },
  {
    id: 80,
    slug: 'ac-not-cooling-summer-troubleshooting-kentucky',
    title: 'AC Blowing Warm Air? 7 Summer Troubleshooting Steps Before You Call for Repair',
    excerpt: 'Before you schedule an emergency AC repair, try these 7 quick troubleshooting steps. Many summer cooling problems in Kentucky homes come down to simple fixes like thermostat settings, tripped breakers, or clogged filters.',
    image: 'https://images.pexels.com/photos/14086132/pexels-photo-14086132.jpeg?auto=compress&cs=tinysrgb&w=800',
    date: 'June 22, 2026',
    dateISO: '2026-06-22',
    readTime: '7 min read',
    category: 'Summer Guide',
    season: 'summer',
    content: `
      <h2>Start with the Simple Stuff</h2>
      <p>An air conditioner that suddenly stops cooling on a hot Kentucky afternoon is stressful. Before you call, run through these steps - you may save yourself a service call.</p>

      <h3>1. Check the Thermostat</h3>
      <p>Make sure it is set to "Cool" (not "Heat" or "Fan"), the set temperature is below room temperature, and the batteries are fresh.</p>
      <h3>2. Inspect the Air Filter</h3>
      <p>A severely clogged filter can block airflow so much that the coil freezes and the system stops cooling.</p>
      <h3>3. Look at the Breakers</h3>
      <p>Your AC typically has two breakers - one for the indoor air handler and one for the outdoor condenser. Reset a tripped breaker once. If it trips again, call a professional.</p>
      <h3>4. Check the Outdoor Disconnect</h3>
      <p>The gray box near your condenser contains a disconnect switch or pull-out block. Make sure it is fully engaged.</p>
      <h3>5. Clear the Condenser</h3>
      <p>Grass clippings, cottonwood fluff, and leaves can choke airflow through the outdoor coil. Turn off the power and gently rinse it with a hose.</p>
      <h3>6. Look for Ice</h3>
      <p>Ice on the refrigerant lines or indoor coil means restricted airflow or low refrigerant. Turn off cooling, run the fan to thaw, and call for service.</p>
      <h3>7. Check the Condensate Drain</h3>
      <p>Many systems have a float switch that shuts the AC off when the drain pan fills. Clearing the drain line can restore cooling.</p>

      <h2>When to Call a Professional</h2>
      <ul>
        <li>The outdoor fan is not spinning or the unit hums without starting</li>
        <li>You hear grinding, squealing, or clicking noises</li>
        <li>The breaker trips more than once</li>
        <li>You smell burning or electrical odors</li>
        <li>Ice keeps returning after thawing</li>
      </ul>
      <p>These usually point to a failed capacitor, motor, contactor, or refrigerant leak - repairs that require a licensed technician.</p>
      ${cta('Still blowing warm air? ComfortMaster offers prompt AC repair with upfront pricing throughout Central Kentucky.')}
    `
  }
];
